package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun ChainLightningMetadata() {
    SpellMetadata(
        spellIndex = "chain-lightning",
        castingTime = "1 action",
        range = "150 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "A bit of fur; a piece of amber, glass, or a crystal rod; and three silver pins.",
        duration = "Instantaneous",
        damageBase = "Lightning 10d8",
        damageScaling = null,
        savingThrow = "DEX (Half)",
        aoe = null,
        concentration = false
    )
}
